export default {
  ordersErrorTitle: {
    id: 'hc_home_orders_error_title',
    defaultMessage: 'We couldn’t load your purchases',
  },
  ordersErrorDescription: {
    id: 'hc_home_orders_error_description',
    defaultMessage:
      'Your purchases aren’t available here right now. Go to My orders to check them.',
  },
  ordersErrorCta: {
    id: 'hc_home_orders_error_cta',
    defaultMessage: 'Go to My orders',
  },
  tradeInsErrorTitle: {
    id: 'hc_home_trade_ins_error_title',
    defaultMessage: 'We couldn’t load your trade-ins',
  },
  tradeInsErrorDescription: {
    id: 'hc_home_trade_ins_error_description',
    defaultMessage:
      'Your trade-ins aren’t available here right now. Go to My trade-ins to check them.',
  },
  tradeInsErrorCta: {
    id: 'hc_home_trade_ins_error_cta',
    defaultMessage: 'Go to My trade-ins',
  },
  noOrdersTitle: {
    id: 'hc_home_orders_empty_title',
    defaultMessage: 'No orders yet',
  },
  noOrdersDescription: {
    id: 'hc_home_orders_empty_description',
    defaultMessage:
      'It’s pretty hard to believe, but it looks like you haven’t ordered any tech yet.',
  },
  noOrdersCta: {
    id: 'hc_home_orders_empty_cta',
    defaultMessage: 'Shop sweet deals',
  },
  noTradeInsTitle: {
    id: 'hc_home_trade_ins_empty_title',
    defaultMessage: 'No trade-ins yet',
  },
  noTradeInsDescription: {
    id: 'hc_home_trade_ins_empty_description',
    defaultMessage:
      'Trade in a device, and get money you want for the tech you don’t need (even broken ones). That easy.',
  },
  noTradeInsCta: {
    id: 'hc_home_trade_ins_empty_cta',
    defaultMessage: 'Get an offer',
  },
  title: {
    id: 'hc_home_orders_section_title',
    defaultMessage: 'Manage your items',
  },
  filterAll: {
    id: 'hc_home_orders_filter_all',
    defaultMessage: 'All',
  },
  filterPurchases: {
    id: 'hc_home_orders_filter_purchases',
    defaultMessage: 'Purchases',
  },
  filterTradeIns: {
    id: 'hc_home_orders_filter_trade_ins',
    defaultMessage: 'Trade-ins',
  },
  filterProtectionPlans: {
    id: 'hc_home_orders_filter_protection_plans',
    defaultMessage: 'Protection Plans',
  },
  seeMoreItems: {
    id: 'hc_home_orders_see_more_items',
    defaultMessage: 'See more items',
  },
  protectionPlansTitle: {
    id: 'hc_home_orders_protection_plans_title',
    defaultMessage: 'We’re working on it!',
  },
  protectionPlansDescription: {
    id: 'hc_home_orders_protection_plans_description',
    defaultMessage:
      'Protection plan details aren’t available here yet. Until then, use your “Protection Plans” page.',
  },
  protectionPlansCta: {
    id: 'hc_home_orders_protection_plans_cta',
    defaultMessage: 'Go to Protection Plans',
  },
  loading: {
    id: 'spinner',
    defaultMessage: 'Loading',
  },
  datePrefixOn: {
    id: 'hc_home_order_card_date_prefix_on',
    defaultMessage: 'On: {date}',
  },
  datePrefixPaymentDueBy: {
    id: 'hc_home_order_card_date_prefix_payment_due_by',
    defaultMessage: 'Payment due by: {date}',
  },
  datePrefixEstimatedDelivery: {
    id: 'hc_home_order_card_date_prefix_estimated_delivery',
    defaultMessage: 'Estimated delivery: {date}',
  },
}
